import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import {Http, Response, Headers, RequestOptions} from '@angular/http';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/delay';
const json = require("json!./../../resources/properties.json");

@Injectable()
export class AuthService {

    private token: string;
    private serverURL: string;

    constructor(private http: Http) {
        this.getTokenService();
        this.serverURL = json.api_url;
    }

    getUserStatus(): number {        
        return Number(localStorage.getItem("userActive"));
    }

    getTokenService() {
        this.token = localStorage.getItem('token');
    }

    private handleError(error: any): Promise<any> {
        console.log(error);
        console.error('An error occurred', error);
        return Promise.reject(error.message || error);
    }

}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/auth.service.ts
 **/